export class LoadingComponent { } 